<template>
  <div class="flex-column menu-column">
    <NuxtLink v-for="(item, idx) in menuItems" :to="`/procedure/${item.table}`" class="menu-link surface-ground py-2">
      <div class="flex p-3">
        <div class="col-2">
          <i class="pi" :class="`pi-${(item as DynamicsType).icon}`"></i>
        </div>
        <div class="col-10 px-0">
          <span>{{ (item as DynamicsType).name }}</span>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
import type { DynamicsType } from '~/server/types/dynamics';
const settings = useGeneralStore();

const { getMenuItems } :any = useSchema();
const menuItems = await getMenuItems();
</script>
<style lang="scss">
@use '@/assets/css/style.scss';
.menu-column{
  max-height: 100%;
  overflow-y: scroll;
  flex-grow: 1;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
.menu-link.router-link-active {
  position: relative;
  &>div {
    background: var(--surface-100);
    color: var(--primary-color);

    &:before,
    &:after {
      content: '';
      top: 0;
      left: 0;
      height: 10px;
      width: 100%;
      background-color: var(--primary-color);
    }

    &:before {
      @include style.BorderRadius($tl: 0, $tr: 0, $br: 10px, $bl: 0, $all: 0);
    }
    &:after {
      top: auto;
      bottom: 0;
      @include style.BorderRadius($tl: 0, $tr: 10px, $br: 0, $bl: 0, $all: 0);
    }
  }
}
</style>